export const ESCAPE = 'escape';
